import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import {
  MobileDatePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./form.module.css";
import {
  filterPaymentMethods,
  getEntity,
  getEntityByProperty,
  getWorkTimeEntity,
} from "../../utils/Filters";
import { ArrowRight, Calendar2Fill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
function RecordInfo({
  setCurrentStep,
  currentStep,
  setUserDetails,
  payments,
  worktimes,
  sites,
  users,
  role,
}) {
  const theme = useTheme();

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const user = useSelector((state) => state.auth.user);
  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]);
  const [userName, setUserName] = useState("");
  const [workingTime, setWorkingTime] = useState("");
  const [selectedMethods, setSelectedMethods] = useState({});
  const [site, setSite] = useState("");
  const [movingSite, setMovingSite] = useState("");
  const [date, setDate] = useState(null);
  const [customTime, setCustomTime] = useState("");
  useEffect(() => {
    setUserName(user.userName);
    setAvailablePaymentMethods(payments);
  }, []);
  const movingSiteOption = {
    id: "moving",
    name: "موقع متحرك",
  };
  let movingSites,
    fixedSites = [];
  if (sites) {
    movingSites = sites.filter((e) => e.type === "متحرك");
    fixedSites = sites.filter((e) => e.type === "ثابت");
  }
  // Filter PaymentMethods Based on SelectedSite
  const handleSiteChange = (e) => {
    setSite(e.target.value);
    if (site !== movingSiteOption.name) {
      let data = filterPaymentMethods(e.target.value, payments);
      setAvailablePaymentMethods(data);
      setSelectedMethods({});
    }
  };
  const handleMovingSiteChange = (e) => {
    setMovingSite(e.target.value);
    if (site !== movingSiteOption.name) {
      let data = filterPaymentMethods(e.target.value, payments);
      setAvailablePaymentMethods(data);
      setSelectedMethods({});
    }
  };

  const handleUserChange = (e) => {
    setUserName(e.target.value);
  };
  const handleWorktimeChange = (e) => {
    setWorkingTime(e.target.value);
  };

  const handleClick = () => {
    const newErrors = {};
    let siteData;
    // Validation
    const paymentMethods = [];
    if (site === movingSiteOption.name) {
      let data = filterPaymentMethods(movingSite, payments);
      siteData = getEntity(movingSites, movingSite);
      paymentMethods.push(...data);
    } else {
      siteData = getEntity(fixedSites, site)
      for (let key in selectedMethods) {
        if (selectedMethods[key] === true) {
          paymentMethods.push(getEntityByProperty("id", payments, Number(key)));
        }
      }
    }

    if (paymentMethods.length === 0 || !paymentMethods)
      newErrors.payments = "يجب أن تختار طريقة دفع واحدة على الأقل.";

    if (!user || !user.userName) newErrors.username = "إسم الموظف مطلوب.";

    if (!site || !getEntity([...sites, movingSiteOption], site))
      newErrors.site = "الموقع مطلوب.";

    if (!workingTime || !getWorkTimeEntity(worktimes, workingTime))
      newErrors.worktime = "مدة العمل مطلوبة.";
    if (workingTime === "غير ذلك" && customTime === "")
      newErrors.worktime = "مدة العمل مطلوبة.";
    if (site === movingSiteOption.name && movingSite === "")
      newErrors.movingSite = "يرجى تحديد الموقع المتحرك.";
    if (!date) newErrors.date = "التاريخ مطلوب.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const userData = {
      user: getEntity(users, userName),
      date: date,
      site: siteData,
      worktime: getWorkTimeEntity(worktimes, workingTime),
      customWorkTime: customTime ? `${customTime} ساعات` : null,
      paymentMethods: paymentMethods,
    };
    if (userData) {
      setUserDetails(userData);
      setCurrentStep(currentStep + 1);
    }
  };


  // Handle individual payment method checkbox change
  const handleMethodChange = (id) => {
    setSelectedMethods((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handleCustomWorktime = (e) => {
    let customTime = parseInt(Number(e.target.value) || 1);
    if (customTime <= 0) {
      customTime = 1;
    }
    if (customTime > 24) {
      customTime = 24;
    }
    setCustomTime(customTime);
  };
  return (
    <Box>
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <Button
          onClick={() => navigate(-1)}
          variant="contained"
          sx={{
            width: "48px",
            height: "48px",
            padding: 0,
            margin: 0,
            minWidth: "auto",
            marginRight: "12px",
          }}
        >
          <ArrowRight size={24} />
        </Button>
        <Typography
          variant="h4"
          color={theme.palette.neutral[900]}
          fontWeight={700}
        >
          إضافة مشاهدات جديدة
        </Typography>
      </div>
      <Box className={styles.formSection}>
        <Typography
          variant="h5"
          color={theme.palette.neutral[800]}
          fontWeight={600}
          marginBottom={2}
        >
          معلومات المستخدم
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={(2, 3)}>
          {/* User Name Field */}
          <FormControl
            fullWidth
            sx={{ flex: "1 1 45%", minWidth: "250px" }}
            error={!!errors.username}
          >
            <InputLabel id="username-label">إسم المستخدم</InputLabel>
            <Select
              fullWidth
              labelId="username-label"
              label="إسم المستخدم"
              value={userName}
              onChange={handleUserChange}
              disabled={role === "Employee"}
            >
              {users?.map((u, index) => (
                <MenuItem key={index} value={u.name}>
                  {u.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.username}</FormHelperText>
          </FormControl>

          <FormControl
            sx={{ flex: "1 1 45%", minWidth: "250px" }}
            error={!!errors.date}
          >
            <MobileDatePicker
              localeText={{
                clearButtonLabel: "مسح",
                okButtonLabel: "تم",
                todayButtonLabel: "اليوم",
                toolbarTitle: "إختار التاريخ",
              }}
              timeZone="UTC"
              label="التاريخ"
              format="YYYY/MM/DD"
              minDate={
                role !== "SuperAdmin" ? dayjs().subtract(1, "day") : undefined
              }
              value={date}
              onChange={(e) => setDate(e)}
              slotProps={{
                textField: {
                  error: !!errors.date,
                  InputProps: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <Calendar2Fill />
                      </InputAdornment>
                    ),
                  },
                },
                actionBar: {
                  actions: ["today", "clear", "accept"],
                },
              }}
            />
            <FormHelperText>{errors.date}</FormHelperText>
          </FormControl>

          <Box
            sx={{
              display: "flex",
              gap: "12px",
              flex: "1 1 45%",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <FormControl
              fullWidth
              sx={{ flex: "1 1 45%", minWidth: "250px" }}
              error={!!errors.site}
            >
              <InputLabel id="site-label">الموقع</InputLabel>
              <Select
                fullWidth
                labelId="site-label"
                label="الموقع"
                value={site}
                onChange={handleSiteChange}
              >
                {[...fixedSites, movingSiteOption]?.map((s, index) => (
                  <MenuItem key={index} value={s.name}>
                    {s.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.site}</FormHelperText>
            </FormControl>
            {site === movingSiteOption.name && (
              <FormControl
                fullWidth
                sx={{ flex: "1 1 45%", minWidth: "250px" }}
                error={!!errors.movingSite}
              >
                <InputLabel id="site-label">الموقع المتحرك</InputLabel>
                <Select
                  fullWidth
                  labelId="site-label"
                  label="الموقع المتحرك"
                  value={movingSite}
                  onChange={handleMovingSiteChange}
                >
                  {movingSites?.map((s, index) => (
                    <MenuItem key={index} value={s.name}>
                      {s.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{errors.movingSite}</FormHelperText>
              </FormControl>
            )}
          </Box>

          <FormControl
            fullWidth
            sx={{ flex: "1 1 45%", minWidth: "250px" }}
            error={!!errors.worktime}
          >
            <Box sx={{ display: "flex" }}>
              <InputLabel id="worktime-label">مدة العمل</InputLabel>
              <Select
                fullWidth
                labelId="worktime-label"
                label="مدة العمل"
                value={workingTime}
                onChange={handleWorktimeChange}
              >
                {worktimes?.map((s, index) => (
                  <MenuItem key={index} value={s.duration}>
                    {s.duration}
                  </MenuItem>
                ))}
              </Select>
              {workingTime === "غير ذلك" ? (
                <TextField
                  sx={{ marginLeft: "12px" }}
                  value={customTime}
                  type="number"
                  error={!!errors.worktime}
                  onChange={handleCustomWorktime}
                  slotProps={{
                    htmlInput: {
                      maxLength: 24,
                    },
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">ساعات</InputAdornment>
                      ),
                    },
                  }}
                />
              ) : (
                ""
              )}
            </Box>
            <FormHelperText>{errors.worktime}</FormHelperText>
          </FormControl>
        </Box>
      </Box>
      {site !== movingSiteOption.name ? (
        <Box className={styles.formSection}>
          <Typography
            variant="h5"
            color={theme.palette.neutral[800]}
            fontWeight={600}
            marginBottom={2}
          >
            إختار طرق الدفع
          </Typography>
          <FormControl error={!!errors.payments}>
            <FormGroup>
              {availablePaymentMethods?.map((method, index) => {
                return (
                  <FormControlLabel
                    key={method.id}
                    control={
                      <Checkbox
                        checked={!!selectedMethods[method.id]}
                        onChange={() => handleMethodChange(method.id)}
                        key={index}
                      />
                    }
                    label={method.name}
                  />
                );
              })}
            </FormGroup>
            <FormHelperText>{errors.payments}</FormHelperText>
          </FormControl>
        </Box>
      ) : (
        ""
      )}
      <Button
        variant="contained"
        color="primary"
        sx={{ fontSize: "20px" }}
        fullWidth
        onClick={handleClick}
      >
        متابعة
      </Button>
    </Box>
  );
}

export default RecordInfo;
